import React from 'react';
import { Link } from 'react-router-dom';
import { services } from './data/content';
import './css/Services.css';

const Services: React.FC = () => {
  return (
    <section className="services" id="services">
      <div className="container">
        <div className="section-header fade-in">
          <div className="section-tag">// What We Do</div>
          <h2>Comprehensive Azure Solutions</h2>
          <p>From cloud migration to custom development, we deliver enterprise-grade solutions</p>
        </div>

        <div className="services-grid" id="services-grid">
          {services.map((service, index) => (
            <div key={index} className={`service-card fade-in${service.featured ? ' service-card--featured' : ''}`}>
              {service.featured && <div className="service-featured-badge">⭐ Featured Service</div>}
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
              {service.link && (
                service.link.url.startsWith('/')
                  ? <Link to={service.link.url} className="service-link">{service.link.label}</Link>
                  : <a href={service.link.url} target="_blank" rel="noopener noreferrer" className="service-link">{service.link.label}</a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
